import { render, staticRenderFns } from "./surveyNavigation.vue?vue&type=template&id=537cd4b0&"
import script from "./surveyNavigation.vue?vue&type=script&lang=js&"
export * from "./surveyNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('537cd4b0', component.options)
    } else {
      api.reload('537cd4b0', component.options)
    }
    module.hot.accept("./surveyNavigation.vue?vue&type=template&id=537cd4b0&", function () {
      api.rerender('537cd4b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/UserProfile/Scripts/Survey/surveyNavigation.vue"
export default component.exports